import React from 'react';
import { connect } from 'react-redux';

import PictureList from '../common/PictureList';
import { fetchPictureData, deletePicture } from '../../actions';
import { Container, Header, Divider, Dropdown, Grid, Message } from "semantic-ui-react";

  const options = [
    { key: 'p', text: 'Patios', value: 'Patios' },
    { key: 'w', text: 'Walls', value: 'Walls' },
    { key: 'a', text: 'Walkways', value: 'Walkways' },
  ];

class PictureAdmin extends React.Component {
    state = {
        category: null,
        messageHidden: true
    }

    handleChange = (e, { value }) => {
        this.props.fetchPictureData(value);
        this.setState( { category: value } );
    }

    sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

    handleDeleteSelected = (pictures) => {
        const {deletePicture } = this.props;
        if (window.confirm(`Are you sure you want to delete these ${pictures.length} image(s)?`)) {
            pictures.forEach(picture => deletePicture(picture.publicId));
            this.setState({messageHidden: false});
            this.sleep(10000).then(() => this.setState({messageHidden: true}));  
        }
    }

    componentDidMount() {
        if(process.env.NODE_ENV === 'development' && !options.find(item => item.key === 't'))
                options.push({ key: 't', text: 'Test', value: 'Test' });
    }
    render() {
        const { pictureData, auth } = this.props;
        if (auth.isSignedIn) {
            return (        
                <Container>
                    <Grid>
                        <Grid.Column width={12}><Header as="h3">Edit Pictures</Header></Grid.Column>
                        <Grid.Column width={4} textAlign="right">
                        <Dropdown 
                        options={options} 
                        placeholder="Select Category"
                        selection
                        onChange={this.handleChange}
                        value={this.state.value}
                    />
                        </Grid.Column>
                    </Grid>
                    <Divider />
                    <Message 
                        success
                        hidden={this.state.messageHidden}
                        header="Picture(s) Have Been Submitted for Deletion"
                        content="However it may take a few minutes for the picture(s) to actually disapear from the administration site and website"
                    />
                    { this.state.category ?
                        <PictureList 
                            pictureData={pictureData} 
                            admin 
                            handleDeleteSelected={this.handleDeleteSelected}
                        />
                    : 
                        <Header as="h4">Please select a category</Header> 
                    }
                </Container>
            );
        } else {
            return <Header as="h3">Please Login</Header>
        }
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        pictureData: state.pictureData
    }
}

export default connect(mapStateToProps, { fetchPictureData, deletePicture })(PictureAdmin);